import React, { useState } from 'react';
import { getColDefs, getRowId } from './gridHelpers';

import ActionsCellRenderer from './ActionsCellRenderer';
import AddButton from 'ui/Buttons/AddButton';
import AgGridReact from 'ui/AgGridReact/AgGridReact';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CreateChartTemplateStepper from './CreateOrEditChartTemplate/CreateChartTemplateStepper';
import HeaderLayout from 'ui/HeaderLayout/HeaderLayout';
import ManageChartTemplateProvider from './ManageChartTemplateContext/ManageChartTemplateProvider';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useGetChartTemplatesTable } from './CreateOrEditChartTemplate/hooks/getChartTemplatesTable';
import { useTranslation } from 'react-i18next';

const StyChartsTemplatesPageContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});

const StyGridContainer = styled('div')({
    padding: '2.5rem',
    width: '100%',
});

const HeaderTitle = (): JSX.Element => {
    const { t } = useTranslation();
    return (
        <Breadcrumbs separator={<ChevronRightIcon />} aria-label="breadcrumb">
            <Typography variant="h4" color="primary">
                {t('support.title')}
            </Typography>
            <Typography variant="h4" color="primary">
                {t('support.chartsTemplates.title')}
            </Typography>
        </Breadcrumbs>
    );
};

const ChartsTemplates = (): JSX.Element => {
    const { t } = useTranslation();
    const [
        showChartTemplateCreationStepper,
        setShowChartTemplateCreationStepper,
    ] = useState(false);

    const { data: chartsTemplates } = useGetChartTemplatesTable();
    if (!chartsTemplates) return <></>;

    const colDefs = getColDefs(t);

    const AddNewChartTemplateButton = (
        <AddButton
            text={t('support.chartsTemplates.create')}
            onClick={() => setShowChartTemplateCreationStepper(true)}
        />
    );

    return (
        <StyChartsTemplatesPageContainer>
            <HeaderLayout
                title={<HeaderTitle />}
                actions={AddNewChartTemplateButton}
            />
            <StyGridContainer>
                <AgGridReact
                    className="ag-theme-material"
                    columnDefs={colDefs}
                    components={{
                        actionsCellRenderer: ActionsCellRenderer,
                    }}
                    domLayout="autoHeight"
                    getRowId={getRowId}
                    pagination
                    paginationPageSize={15}
                    rowData={chartsTemplates}
                    rowHeight={50}
                />
            </StyGridContainer>
            {showChartTemplateCreationStepper && (
                <ManageChartTemplateProvider>
                    <CreateChartTemplateStepper
                        open={showChartTemplateCreationStepper}
                        setOpen={setShowChartTemplateCreationStepper}
                    />
                </ManageChartTemplateProvider>
            )}
        </StyChartsTemplatesPageContainer>
    );
};

export default ChartsTemplates;
